<template lang="html">
    <div class="page-container">
        <div class="page-container__header client-payments__header">
            <h1 class="header-1 page-container__title">Plățile mele</h1>
            <div class="client-payments__header__list-type">
                <i class="fas fa-list-ul" :class="{ active: paymentsAppearance === 'list' }"
                    @click="clientPaymentsAppearance('list')" />
                <i class="fas fa-border-all" :class="{ active: paymentsAppearance === 'grid' }"
                    @click="clientPaymentsAppearance('grid')" />
            </div>
        </div>
        <div class="page-container__body" v-if="paymentsLoading || !clientPayments">
            <div class="client-payments__container client-payments__container--list">
                <PaymentList :skeleton="true" />
                <PaymentList :skeleton="true" />
                <PaymentList :skeleton="true" />
                <PaymentList :skeleton="true" />
            </div>
            <div class="client-payments__container client-payments__container--mobile">
                <PaymentCard :skeleton="true"/>
                <PaymentCard :skeleton="true"/>
                <PaymentCard :skeleton="true"/>
            </div>
        </div>
        <div class="page-container__body" v-else>
            <div class="client-payments__container client-payments__container--list"
                v-if="paymentsAppearance == 'list'">
                <PaymentList v-for="(payment, i) in clientPayments" :key="i" :number="i" :date="payment.created_at"
                    :price="payment.price" :vat="payment.vat" :currency="payment.currency" :type="payment.type"
                    :invoice="payment.invoice" />
            </div>
            <div class="client-payments__container client-payments__container--grid" v-else>
                <PaymentCard v-for="(payment, i) in clientPayments" :key="i" :date="payment.created_at"
                    :price="payment.price" :vat="payment.vat" :currency="payment.currency" :type="payment.type"
                    :invoice="payment.invoice" />
            </div>
            <div class="client-payments__container client-payments__container--mobile">
                <PaymentCard v-for="(payment, i) in clientPayments" :key="i" :date="payment.created_at"
                    :price="payment.price" :vat="payment.vat" :currency="payment.currency" :type="payment.type"
                    :invoice="payment.invoice"/>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import Card from '@/components/ui/Card'
    import PaymentList from './components/PaymentList'
    import PaymentCard from './components/PaymentCard'

    import {
        mapActions
    } from 'vuex'
    import {
        mapGetters
    } from 'vuex'

    export default {
        components: {
            Card,
            PaymentList,
            PaymentCard
        },
        computed: {
            ...mapGetters({
                paymentsAppearance: 'payments/paymentsAppearance',
                clientPayments: 'payments/clientPayments',
                paymentsLoading: 'payments/paymentsLoading'
            })
        },
        methods: {
            ...mapActions({
                clientPaymentsAppearance: 'payments/clientPaymentsAppearance',
                getClientPayments: 'payments/clientPayments'
            })
        },
        mounted() {
            this.getClientPayments();
            console.log(this.clientPayments);
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/scss/pages/_client-payments.scss';
</style>